import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {LorenBaseFeature} from '../../../../shared/base-components/loren-base-feature/loren-base-feature';
import {LorenNotification} from '../../../../shared/services/loren-notification-service/interfaces/loren-notification.interface';
import {LorenNotificationResolverConstant} from '../../resolvers/constants/loren-notification-resolver.constants';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {LorenNotificationService} from '../../../../shared/services/loren-notification-service/loren-notification.service';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector: 'loren-notification-details',
    templateUrl: './loren-notification-details.component.html',
    styleUrls: ['./loren-notification-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LorenNotificationDetailsComponent extends LorenBaseFeature implements OnInit {
    private activatedRoute = inject(ActivatedRoute);
    private router = inject(Router);
    private notificationService = inject(LorenNotificationService);

    notification: LorenNotification;

    ngOnInit(): void {
        this.loadNotificationEntity();
        this.router.events.pipe(
            takeUntilDestroyed(this.destroyRef),
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.loadNotificationEntity();
        });
    }

    private loadNotificationEntity() {
        this.notification = this.activatedRoute.snapshot.data[LorenNotificationResolverConstant.NOTIFICATION];
        if (!this.notification.seen) {
            this.updateNotificationAsSeen();
        }
    }

    private updateNotificationAsSeen() {
        this.notificationService.updateNotificationStatus(this.notification.id)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                this.notificationService.publishNotificationStatusUpdateEvent(this.notification.id);
            })
    }
}
